import {createSlice} from "@reduxjs/toolkit";

import {TERM_10_YEARS} from "shared/constants/terms";
import {MONTHLY} from "shared/constants/payment";


const initialState = {
    valid: false,
    data: {
        amount: 500000,
        term: TERM_10_YEARS,
        payment: MONTHLY
    }
};

const quoteInputSlice = createSlice({
    name: 'quoteInput',
    initialState,
    reducers: {
        setInputValue: (state, action) => {
            Object.assign(state.data, action.payload);
        },
        setValid: (state, action) => {
            state.valid = action.payload;
        }
    },
});

export const { setInputValue, setValid } = quoteInputSlice.actions;
export default quoteInputSlice.reducer;
